// extracted by mini-css-extract-plugin
export default {"small-button":"CreateUser_small-button__2b1qA"};